import React from 'react';
import Modal from 'react-modal';

import { Axis } from './axis';
import CombinedBody from './combinedBody';
import Disclaimer from './disclaimer';
import GameContext from './gameContext';
import GameInputs from './gameInputs';
import { DEFAULT_STATE } from './gameState';
import { NextSteps } from './nextSteps';

class Game extends React.Component {
  constructor(props) {
    super(props);

    this.patientSite = props.patientSite;
    this.changeState = (newState) => this.setState(newState);
    this.state = {
      ...DEFAULT_STATE,
      changeState: this.changeState,
      showDisclaimer: true,
      showDone: false
    };
  }

  closeDisclaimer = () => {
    this.setState({
      ...this.state,
      showDisclaimer: false
    });
  }

  resetGame = () => {
    // reset axis counts
    for (const overlay in this.state.axis) {
      this.state.axis[overlay].count = 0;
    }
    
    // reset state
    this.setState({
      ...this.state,
      ...DEFAULT_STATE,
      showDisclaimer: false,  // don't show the disclaimer again
      showDone: false
    });
  }

  openDone = () => {
    this.setState({
      ...this.state,
      showDone: true
    })
  }

  closeDone = () => {
    this.setState({
      ...this.state,
      showDone: false
    })
  }

  finishGame = () => {
    this.closeDone();
  }

  render() {
    Modal.setAppElement('#root');

    return (
      <div id="game">
        <div className="game-header">
          <h2>Anabolic Androgenic Steroid Simulator</h2>
          <div className="game-header-right">
            <button className="game-input-btn" onClick={this.resetGame}>Reset</button>
            {/* <button className="game-input-btn" onClick={this.openDone}>Done</button> */}
          </div>
        </div>
        <div className="game-container">
          <GameContext.Provider value={this.state}>
            <div className="game">
              {/* left */}
              <div>
                <GameInputs/>
              </div>

              {/* right */}
              <div className="bodies">
                <CombinedBody/>
                <Axis/>
              </div>
            </div>

            <NextSteps patientSite={this.patientSite}/>

            {/* finish modal */}
            {/* <Modal
              isOpen={this.state.showDone}
              className="modal"
              contentLabel="Done"
              style={{ overlay: { background: "rgba(0, 0, 0, 0.5)" } }}
            >
              <NextStepsForm close={this.closeDone} finish={this.finishGame} isOpen={this.showDone}/>
            </Modal> */}
          </GameContext.Provider>
        </div>

        {/* disclaimer modal */}
        <Modal
          isOpen={this.state.showDisclaimer}
          className="modal"
          contentLabel="Disclaimer"
          style={{ overlay: { background: "rgba(0, 0, 0, 0.5)" } }}
        >
          <Disclaimer close={this.closeDisclaimer}/>
        </Modal>
      </div>
    );
  }
}

export default Game;